var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.843 11.815q-2.448 0-4.145-1.717Q0 8.382 0 5.908t1.698-4.192T5.843 0Q8.29 0 9.988 1.716q1.697 1.717 1.697 4.191 0 1.035-.343 1.977a5.5 5.5 0 0 1-.917 1.638l3.372 2.97q.198.2.203.504a.69.69 0 0 1-.203.513.68.68 0 0 1-.504.21.68.68 0 0 1-.503-.21L9.418 10.54a5.5 5.5 0 0 1-1.648.936 5.6 5.6 0 0 1-1.927.338m0-1.45q1.845 0 3.128-1.295 1.281-1.296 1.281-3.163T8.971 2.745 5.843 1.449q-1.847 0-3.128 1.296Q1.433 4.04 1.433 5.907q0 1.868 1.282 3.163 1.281 1.296 3.128 1.296"
  })));
};
export default SvgSearchIcon;